<template>
    <EditPersonnel2/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import EditPersonnel2 from "@/components/GesCom/Personnel/EditPersonnel2.vue";

    export default defineComponent({
      name: "EditPersonnellePage2",
      components: {        
        EditPersonnel2,
      },
    });
  </script>

